function change(id, w, h) {
  //演示三 ID改变下试试
  $(id).jcImgScroll({
    arrow: {
      width: 100,
      height: 400,
      x: 100,
      y: 0,
    },
    width: w, //设置图片宽度
    height: h, //设置图片高度
    imgtop: 30, //每张图片的上下偏移量
    imgleft: -50, //每张图片的左边偏移量
    imgwidth: 30, //每张图片的宽度偏移量
    imgheight: 60, //每张图片的高度偏移量
    count: 5,
    offsetX: 80,
    NumBtn: false,
    title: false,
    setZoom: 0.8,
  });
};

export {
  change
}



// WEBPACK FOOTER //
// ./src/js/change.js